import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'

const AlertModal = ({ show, onHide, title, message }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: '1.1em', fontWeight: 'bold', color: '#00a651' }}>
          {title || 'Pemberitahuan'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '20px 24px', textAlign: 'center' }}>
        <p style={{ fontSize: '1em', color: '#333', marginBottom: '20px' }}>
          {message}
        </p>
        <button
          type="button"
          onClick={onHide}
          style={{
            padding: '8px 24px',
            borderRadius: '6px',
            border: 'none',
            backgroundColor: '#00a651',
            color: '#fff',
            fontWeight: 'bold',
            cursor: 'pointer',
            outline: 'none'
          }}
        >
          OK
        </button>
      </Modal.Body>
    </Modal>
  )
}

AlertModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string
}

export default AlertModal
